let captchaToken: string | null = null;
let captchaTokenExpiry: string | null = null;

export function setCaptchaAccessToken(token: string, expiresOn: string): void {
    captchaToken = token;
    captchaTokenExpiry = expiresOn;
}

export function clearCaptchaAccessToken(): void {
    captchaToken = null;
    captchaTokenExpiry = null;
}

export function getCaptchaAccessToken(): string | null {
    return isTokenValid(captchaToken, captchaTokenExpiry) ? captchaToken : null;
}

export function isCaptchaAccessTokenExpired(): boolean {
    return getCaptchaAccessToken() === null;
}

function isTokenValid(token: string | null, expiresOn: string | null): boolean {
    if (!token || !expiresOn) {
        return false;
    }

    const parsedExpiry = Date.parse(expiresOn);
    return !Number.isNaN(parsedExpiry) && Date.now() <= parsedExpiry;
}